module.exports = __webpack_public_path__ + "static/media/mobile-menu-icon.5bbd003d.svg";